import { Component, EventEmitter, Output } from '@angular/core';
import {NgForOf} from "@angular/common";

@Component({
  selector: 'app-verification-code',
  templateUrl: './verification-code.component.html',
  styleUrls: ['./verification-code.component.scss'],
  imports: [
    NgForOf
  ],
  standalone: true
})
export class VerificationCodeComponent {
  @Output() code: EventEmitter<string> = new EventEmitter<string>();

  inputCode: string = '';

  digits = Array( 6 ).fill( '' );

  onInput( event: { target: HTMLInputElement }, index: number ): void {
    const input = event.target as HTMLInputElement;
    const value = input.value;

    if ( /^\d$/.test( value ) ) {
      this.digits[index] = value;
      this.updateInputCode();
      if ( index === 5 && this.inputCode.toString().length === 6 ) {
        this.code.emit( this.inputCode );
      }
      input.value = '';


    } else {
      this.digits[index] = '';
      input.value = '';

    }

  }

  private updateInputCode(): void {
    this.inputCode = this.digits.join( '' );
    if ( this.inputCode.toString().length === 6 ) {
      this.code.emit( this.inputCode );
    }
  }

  onPaste(event: ClipboardEvent): void {
    event.preventDefault();
    const pasteData = event.clipboardData?.getData('text') ?? '';
    if (!/^\d{6}$/.test(pasteData)) {
      return; // ignore invalid paste
    }

    this.digits = pasteData.split('');
    this.updateInputCode();

    this.code.emit(this.inputCode);
  }

}
